// Ruby I18n and vue-i18n both emit these, and the Stimulus controller reads both.
export const START = "⁢" // INVISIBLE TIMES
export const SEP = "⁣" // INVISIBLE SEPARATOR
export const STOP = "⁤" // INVISIBLE PLUS
const ZERO = "‌" // ZERO WIDTH NON-JOINER
const ONE = "‍" // ZERO WIDTH JOINER

export const KEY_BITS = `[${ZERO}${ONE}]*`

// Zero-width bits rather than the key itself: plain text would be painted, and
// every string would visibly flicker from key to copy when the widget strips it
// a frame later.
const encodeKey = (key) =>
  Array.from(new TextEncoder().encode(key))
    .map((byte) => byte.toString(2).padStart(8, "0"))
    .join("")
    .replaceAll("0", ZERO)
    .replaceAll("1", ONE)

export const decodeKey = (bits) => {
  const binary = Array.from(bits, (bit) => (bit === ZERO ? "0" : "1")).join("")
  const bytes = binary.match(/.{8}/g) ?? []

  return new TextDecoder().decode(Uint8Array.from(bytes, (byte) => parseInt(byte, 2)))
}

export const mark = (key, copy) => `${START}${encodeKey(key)}${SEP}${copy}${STOP}`

// Read on every call: Vue mounts from a Stimulus connect that can run before
// turbo:load, so a cached flag is stale exactly when a session is starting.
export const proofreading = () => !!document.querySelector('meta[name="proofreading"]')
